// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__313fs","select":"Header_select__Vv_ks","clinic":"Header_clinic__3kSFl"};